import React, { useState } from "react";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { useNavigate } from "react-router-dom";
import styles from "./EquipmentDetails.module.css";
import { TextComponent } from "../../../../../components";
import { Table } from "antd";
import TopTabComponent from "../../../../../components/TopTabComponent/TopTabComponent";
import BasicInfo from "./BasicInfo/BasicInfo";
import MaintenanceLog from "./MaintenanceLog/MaintenanceLog";

const StandMixer = () => {
  const navigate = useNavigate();

  const [parameterData, setParameterData] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",
    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "250",
    },
  ]);

  const columns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const MainTabs = [
    { id: 1, name: "Basic Info" },
    { id: 2, name: "Maintenance Log" },
  ];
  const [MainfocusedTab, setMainFocusedTab] = useState(MainTabs[0]);

  return (
    <div>
      <HeaderComponent
        heading={"Stand Mixer"}
        onSearch={(e) => console.log(e.target.value)}
        // onSubmit={() => navigate("/CreateNewStaffUser")}
        submitButtonText={false}
        //  onDelete={true}
        // onEdit={onEdit}
        showBackIcon={true}
        showControlButtons={true}
        showFilterIcon={false}
        showSubmitButton={false}
        showSearch={false}
      />

      <TopTabComponent
        options={MainTabs}
        focused={MainfocusedTab}
        setFocused={setMainFocusedTab}
        TopTabListStyle={styles.MainTopTabListStyle}
      />

      {MainfocusedTab?.name === "Basic Info" ? (
        <BasicInfo />
      ) : (
        <MaintenanceLog />
      )}
    </div>
  );
};

export default StandMixer;
